<template>
    <div class="card_footer">
        <dl class="textInfo">
            <dt>
                {{ maxOddsText }}:
            </dt>
            <dd v-bind:class="{ 'odds-change': oddsChanging }">
                <SboIcon
                    v-if="isSuspended"
                    name="system:lock"
                    class="locked"
                    size="16"
                />
                <template v-else>
                    @{{ maxOdds }}
                </template>
            </dd>
        </dl>
        <Cta
            v-bind:customClass="btnClass"
            v-bind:ga="addToSlipGa"
            v-bind:disabled="isSuspended"
            v-bind:onClick="addToBetSlip"
        >
            <strong>{{ addToSlipText }}</strong>
        </Cta>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import Cta from '@/components/common/Cta.vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { i18n } from '@/libraries/i18n';

    interface Props {
        maxOdds: string;
        oddsChanging: boolean;
        isSuspended: boolean;
        addToSlipGa: string;
    }

    const props = defineProps<Props>();

    const emit = defineEmits<(e: 'addToSlip') => void>();

    const maxOddsText = computed(() => i18n.t('popular_combination_max_odds'));
    const addToSlipText = computed(() => i18n.t('popular_combination_button_add_to_slip'));
    const btnClass = computed(() => ['btn', 'btn-accent', props.isSuspended ? '_disabled' : '']);

    function addToBetSlip() {
        emit('addToSlip');
    }
</script>

<style lang="scss" scoped>
@import "@/scss/components/quickCombination";
</style>
